import React from "react";
import { Zap, ChevronRight, Search, Gift, Star } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import EventTabs from "./EventTabs";
import PromoCard from "./PromoCard";
import LeagueCard from "./LeagueCard";
import { Link } from "react-router-dom";
import FeaturedMatches from "./components/FeaturedMatches";
export default function HomeContent() {
  return (
    <div className="px-3 pt-3">
      {/* Sección de búsqueda */}
      <motion.div
        className="relative mb-4"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="relative">
          <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
          <input
            type="text"
            placeholder="Buscar equipos, ligas o partidos..."
            className="w-full bg-gray-800 text-white rounded-lg py-2 pl-9 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
        </div>
      </motion.div>

      {/* Pestañas de filtro */}
      <EventTabs />

      {/* Promociones - Scroll horizontal */}
      <motion.div
        className="mb-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <div className="flex justify-between items-center mb-3">
          <div className="flex items-center">
            <Gift className="w-5 h-5 text-yellow-500 mr-2" />
            <h2 className="text-white font-medium">Promociones</h2>
          </div>
          <Link
            to="/sin-ruta"
            className="flex items-center text-gray-400 hover:text-white cursor-pointer"
          >
            <span className="text-xs mr-1">Ver todas</span>
            <ChevronRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Scroll horizontal para promociones */}
        <div className="flex overflow-x-auto pb-2 gap-3 scrollbar-hide">
          <PromoCard
            title="¡Bono de Bienvenida!"
            subtitle="Hasta $200"
            color="bg-gradient-to-br from-blue-800 to-blue-900"
            path="/promociones/bono-bienvenida"
          />
          <PromoCard
            title="¡Apuesta Sin Riesgo!"
            subtitle="Primer apuesta"
            color="bg-gradient-to-br from-green-800 to-green-900"
            path="/promociones/apuesta-sin-riesgo"
          />
          <PromoCard
            title="Recarga COMPLETA"
            subtitle="50% extra"
            color="bg-gradient-to-br from-purple-800 to-purple-900"
            path="/promociones/recarga-completa"
          />
          <PromoCard
            title="Giros Gratis"
            subtitle="Casino Online"
            color="bg-gradient-to-br from-red-800 to-red-900"
            path="/promociones/giros-gratis"
          />
        </div>
      </motion.div>

      {/* Ligas Populares */}
      <motion.div
        className="mb-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center">
            <Star className="w-5 h-5 text-yellow-500 mr-2" />
            <h2 className="text-white font-medium">Ligas Populares</h2>
          </div>
          <Link
            to="/sin-ruta"
            className="flex items-center text-gray-400 hover:text-white cursor-pointer"
          >
            <span className="text-xs mr-1">Ver todas</span>
            <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid grid-cols-4 gap-2">
          <LeagueCard name="Copa Libertadores" icon="🏆" matches="8 partidos" />
          <LeagueCard name="La Liga" icon="🇪🇸" matches="12 partidos" />
          <LeagueCard name="Premier" icon="🏴󠁧󠁢󠁥󠁮󠁧󠁿" matches="10 partidos" />
          <LeagueCard name="Serie A" icon="🇮🇹" matches="6 partidos" />
        </div>
      </motion.div>

      {/* Partidos Destacados */}
      <FeaturedMatches/>
    </div>
  );
}
